import React from "react";
import { PatientDocumentPOCItem, POCItemsDocumentAnswer } from "../../messages/PatientDocuments";
import { TaskWhenToPerform } from "../../messages/PlanOfCare";
import { AppCard, AppCardContent } from "../Generic/AppCard";
import classNames from "classnames";
import Flex from "../Generic/Flex";
import { POCItem } from "./POCItem";

interface POCDocumentQuestionUIProps {
  questionId: number;
  questionText: string;
  currentAnswer: POCItemsDocumentAnswer[] | null;
  POCItems: PatientDocumentPOCItem[];
  isRequired: boolean;
  isValid: boolean;
  readonly: boolean;
  onTaskCheck: (itemIndex: number) => void;
  onWhenToPerformChange: (itemIndex: number, whenToPerform: TaskWhenToPerform) => void;
  onFrequencyChange: (
    itemIndex: number,
    frequency: number | null,
    visitsInAWeek: number | null
  ) => void;
  onNotesChange: (itemIndex: number, notes: string) => void;
}

export function POCDocumentQuestionUI(props: POCDocumentQuestionUIProps) {
  return (
    <AppCard className={classNames({ __invalid: !props.isValid })}>
      <AppCardContent>
        <Flex direction="column" gap={8}>
          {props.POCItems.map((item, index) => (
            <POCItem
              key={index}
              item={item}
              index={index}
              currentAnswer={props.currentAnswer}
              isRequired={props.isRequired}
              readonly={props.readonly}
              onTaskCheck={props.onTaskCheck}
              onWhenToPerformChange={props.onWhenToPerformChange}
              onFrequencyChange={props.onFrequencyChange}
              onNotesChange={props.onNotesChange}
            />
          ))}
        </Flex>
      </AppCardContent>
    </AppCard>
  );
}
